module.exports = __webpack_public_path__ + "img/4267102.png";